import * as React from "react";
import {BaseFormViewState, default as BaseFormView} from "../../../ui/form/BaseFormView";
import {none, option, Option} from "ts-option";
import FormButtonsView from "../../../ui/form/FormButtonsView";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import QuoteFormBody from "../QuoteFormBody";
import QuoteForm from "../QuoteForm";
import Quote from "../../../../model/quote/Quote";
import Brand from "../../../../model/brand/Brand";
import ReviewQuoteFormBody from "../ReviewQuoteFormBody";
import {BrandTasks} from "../../../../store/reducer/task/TaskState";
import Row from "../../../layout/Row";
import Col from "../../../layout/Col";
import ButtonSecondary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonSecondary";
import PartnerBrand from "../../../../model/partnerBrand/PartnerBrand";

interface IComponentProps {
	/**
	 * On submit callback. Should call only when form is valid.
	 * @param {Quote} q
	 */
	onSubmit: (q: Quote) => void;
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * Lead id
	 */
	leadId: string
	/**
	 * Brand
	 */
	brand: Brand
	/**
	 * Partner brand
	 */
	partnerBrand: Option<PartnerBrand>
	/**
	 * Vat value
	 */
	vat: number,
}

interface State {
	/**
	 * Created quote - appears after click on 'Review' button
	 */
	quote: Option<Quote>
}

type IState = BaseFormViewState<QuoteForm> & State;

export default class CreateQuoteFormView extends BaseFormView<QuoteForm, IComponentProps, IState> {
	constructor(props: IComponentProps) {
		super(props);
		const {partnerBrand, brand, vat, leadId} = this.props;
		const vatRegistered = partnerBrand.map(pb => pb.vatRegistered).getOrElse(brand.vatRegistered);
		const labourCost = partnerBrand.map(pb => pb.labourCost).getOrElse(brand.labourCost);
		const markup = partnerBrand.map(pb => pb.markup).getOrElse(0);
		this.state = {
			form: QuoteForm.createEmpty(leadId, brand.id, partnerBrand.map(pb => pb.id), vat, markup, labourCost, vatRegistered,
				brand.maxFee),
			isFormDirty: false,
			shouldValidate: false,
			quote: none
		};
		this.onQuoteToReviewReady = this.onQuoteToReviewReady.bind(this);
	}

	render() {
		return this.state.quote.isDefined ? this.renderQuoteReviewForm() : this.renderQuoteCreationForm();
	}

	renderQuoteReviewForm() {
		return (
			<div>
				<ReviewQuoteFormBody quote={this.state.quote.get}
									 form={this.state.form}
									 onFieldChange={this.onFieldChanged}
									 onFieldCompleted={this.onFieldCompleted}
									 onFocusChange={this.onFocusChange}
									 onFieldsChange={this.onFieldsChanged}
									 onQuoteChange={(quote) => this.setState({quote: option(quote)})}/>
				<Row>
					<Col>
						<div className={"c-quote-button-left"}>
							<ButtonSecondary onClick={() => this.setState({quote: none})}
											 label={"Back"}
											 disabled={this.props.isSubmitting}/>
						</div>
						<div className={"c-quote-button-right"}>
							<ButtonPrimary onClick={() => this.submitReviewFormAndCreateQuote()}
										   label={"Create quote"}
										   disabled={this.props.isSubmitting}/>
						</div>
					</Col>
				</Row>
			</div>
		);
	}

	renderQuoteCreationForm() {
		return (
			<div>
				<QuoteFormBody form={this.state.form}
							   onFieldChange={this.onFieldChanged}
							   onFieldCompleted={this.onFieldCompleted}
							   onFocusChange={this.onFocusChange}
							   onFieldsChange={this.onFieldsChanged}
							   bespokeItemMarkup={this.props.brand.customPartsMarkup}/>
				<FormButtonsView align={"right"}>
					<ButtonPrimary onClick={() => this.submitForm()}
								   label={"Review quote"}
								   disabled={this.props.isSubmitting}/>
				</FormButtonsView>
			</div>
		);
	}

	/**
	 * Create quote method
	 */
	submitReviewFormAndCreateQuote() {
		this.state.quote.map(this.props.onSubmit);
	}

	onQuoteToReviewReady(quote: Quote) {
		this.setState({quote: option(quote)});
	}

	/**
	 * Check create form and go to review
	 */
	submitForm(): void {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onValid(this.onQuoteToReviewReady, () => {this.setState({quote: none})});
		});
	}
}
